import React, { MouseEventHandler, RefObject, forwardRef } from 'react';
import { setClass } from '@utils';
import { PropsWithChildren } from 'react';
import '../../styles/components/svg.scss';

interface SvgWraperProps {
  divClassName?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const SvgWrapperTooltipSupport = forwardRef<HTMLDivElement,PropsWithChildren<SvgWraperProps>>((
  props, ref: RefObject<HTMLDivElement>
) => {
  const { divClassName, onClick, children, ...tooltipProps } = props;
  
  return (
    <div 
      onClick={onClick}
      {...tooltipProps}
      className={setClass(onClick && 'clickable', 'svg', props.divClassName)}
      ref={ref}
    >
      {children}
    </div>
  )
});
